import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './login-page.css';
import { FormField } from '../../common/Forms';
import { urlConst } from '../../../consts';
import { userActions } from '../../../actions';
import { renderErrors } from '../../common/Forms/utils';
import { VkLoginButton } from './VkLoginButton';

const loginField = {
    id: 'username',
    name: 'Логин',
    inputType: 'text',
    required: true,
};
const passField = {
    id: 'password',
    name: 'Пароль',
    inputType: 'password',
    required: true,
};

const initialFormData = {
    username: '',
    password: '',
};

function LoginPage(props) {
    const { logining, login, errors, clearErrors } = props;

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        return () => clearErrors();
    }, [clearErrors]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const { username, password } = formData;
        if (username && password) {
            login(username, password);
        }
    };

    const handleChange = (value, name) => {
        setFormData((old) => {
            return {
                ...old,
                [name]: value,
            };
        });
        if (errors) clearErrors();
    };

    return (
        <Container className="login-page py-5">
            <div className="form-container">
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <FormField
                            field={loginField}
                            placeholder="Введите email или ID пользователя"
                            value={formData.username}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group>
                        <div className="position-relative">
                            <FormField
                                field={passField}
                                placeholder="Введите пароль"
                                value={formData.password}
                                onChange={handleChange}
                            />
                            <Link className="small forget-link" to={urlConst.RESET_PASS}>
                                Забыли пароль?
                            </Link>
                        </div>
                    </Form.Group>

                    {errors && errors.globalError && <Alert variant="danger">{renderErrors(errors.globalError)}</Alert>}

                    <Form.Group className="text-center">
                        <Button variant="outline-primary" type="submit" className="px-5" disabled={logining}>
                            {logining && (
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            )}
                            <span>Войти</span>
                        </Button>
                    </Form.Group>
                </Form>
            </div>
            <div className="form-container text-center">
                <p className="small">
                    Еще нет аккаунта?
                    <Link className="ml-1" to={urlConst.REGISTRATION}>
                        Зарегистрироваться!
                    </Link>
                </p>
            </div>
            <div className="text-center mt-3 login-page-footer">
                <p>или</p>
                <VkLoginButton />
            </div>
        </Container>
    );
}

function mapStateToProps(state) {
    const { logining, errors } = state.auth;
    return { logining, errors };
}

const dispatchToProps = {
    login: userActions.login,
    logout: userActions.logout,
    clearErrors: userActions.clearErrors,
};

export default connect(mapStateToProps, dispatchToProps)(LoginPage);
